/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import React from "react";

const initState = "status"; // board view field key to use boards

const BoardViewContext = React.createContext(initState);
export const useBoardViewOption = () => React.useContext(BoardViewContext);

const BoardViewSwitchContext = React.createContext(() => {});
export const useSwitchBoardViewOption = () =>
    React.useContext(BoardViewSwitchContext);

export default ({ children }) => {
    const [value, setValue] = React.useState(() => initState);
    return (
        <BoardViewContext.Provider value={value}>
            <BoardViewSwitchContext.Provider
                value={(v) => {
                    setValue(v);
                }}
            >
                {children}
            </BoardViewSwitchContext.Provider>
        </BoardViewContext.Provider>
    );
};
